export const stubCustomerData = {
  customer: {
    firstname: 'Flow Ryan',
    lastname: 'Schmerz',
    email: 'webpresence-team@codetain.com',
    wishlists: [
      {
        id: '1',
        items_count: 1,
        items_v2: {
          items: [
            {
              id: '1234',
              quantity: 3,
              product: {
                sku: '001-007-000041',
              },
            },
          ],
        },
      },
      {
        id: '2',
        items_count: 2,
        items_v2: {
          items: [
            {
              id: '4321',
              quantity: 2,
              product: {
                sku: '001-007-000041',
              },
            },
          ],
        },
      },
      {
        id: '3',
        items_count: 2,
        items_v2: {
          items: [],
        },
      },
    ],
  },
  customerCart: {
    id: 'ph8FEPVqozjDC0Q7YeD5fQfl8Z6QP5iC',
    items: [
      {
        uid: 'MjQ2Njg5',
        quantity: 3,
        product: {
          sku: '001-013-000022',
          name: 'ABL | Ladestation eMH1',
          url: 'https://www.mobilityhouse.com/de_de/abl-wallbox-emh1-1w1101.html',
          small_image: {
            url: 'https://apollo.mobilityhouse.com/media/catalog/product/cache/1ab73a1710d58f4597d739718633a39e/s/h/shop_abl-emh1_selbst-konfigurieren_2018-07-03.png',
          },
          configured_variant: {
            small_image: {
              url: 'https://apollo.mobilityhouse.com/media/catalog/product/cache/1ab73a1710d58f4597d739718633a39e/z/a/zaptec_go_01_adapter_type_g_1600x1200px.jpg',
            },
          },
          price: {
            regular: 889,
            reduced: 389,
            discount: 56.24,
          },
        },
        rowPriceExcludingTax: 1500,
        rowPriceIncludingTax: 1785,
        options: [
          {
            label: 'Option 1',
            value: 'Laborum anim',
          },
          {
            label: 'Option 2',
            value: 'Elit nostrud ea',
          },
        ],
      },
      {
        uid: 'MzMy',
        quantity: 1,
        product: {
          sku: '001-013-000022',
          name: 'JUICE BOOSTER 2 Adapter',
          url: 'https://www.mobilityhouse.com/de_de/adapter-juice-booster-typ-g-gb.html',
          small_image: {
            url: 'https://apollo.mobilityhouse.com/media/catalog/product/cache/1ab73a1710d58f4597d739718633a39e/z/a/zaptec_go_01_adapter_type_g_1600x1200px.jpg',
          },
          price: {
            regular: 889,
            reduced: 389,
            discount: 56.24,
          },
        },
        rowPriceExcludingTax: 57.98,
        rowPriceIncludingTax: 69,
        options: [],
      },
    ],
    totalQuantity: 4,
    subtotalExcludingTax: 1557.98,
    subtotalIncludingTax: 1854,
  },
};
